import { number, percentage } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'

interface CtrCellProps {
    ctr: number
    impressions: number
    clicks: number
}

export const CtrCell = (v: CtrCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)

    let ctr = g('ctr')
    if (extra?.recipe_version === 2) {
        ctr = ctr * 100.0
    }

    const lines = [
        { description: 'Clicks', value: number(g('clicks'), 0) ?? '' },
        { description: '÷ Impressions', value: number(g('impressions'), 0) ?? '' },
        { description: 'CTR', value: percentage(ctr) ?? '' },
    ]

    return <Calculation lines={lines}>{percentage(ctr)}</Calculation>
}
